import { render, staticRenderFns } from "./InformativesPage.vue?vue&type=template&id=7a5a85a4&"
import script from "./InformativesPage.vue?vue&type=script&lang=js&"
export * from "./InformativesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports